import PropTypes from "prop-types"

import "./pro_diy_banner.scss"
import { ProDIYBannerAndFooterCopies } from "./utils/pro_diy_banner_copies"

const ProDiyBanner = ({ onClick, urls, userTier }) => {
  let bannerTitle = ProDIYBannerAndFooterCopies.title
  let buttonLabel = ProDIYBannerAndFooterCopies.buttonLabel
  let url = urls.newProSubscriptionUrl
  let onClickHandle

  if (userTier === "intermediate_pro") {
    bannerTitle = ProDIYBannerAndFooterCopies.titleForUpgradePro
    url = undefined
    onClickHandle = onClick
  }

  return (
    <a
      href={url}
      onClick={onClickHandle}
      data-turbolinks="false"
      className="pro-diy-banner"
      styleName="pro-diy-banner"
      data-track-ifttt-next-event="click"
      data-track-data={JSON.stringify({
        object_type: "get_pro_cta",
        location_type: "diy_composer",
      })}
    >
      <div>
        {bannerTitle} <span styleName="cta">{buttonLabel}</span>
      </div>
    </a>
  )
}

ProDiyBanner.propTypes = {
  onClick: PropTypes.func.isRequired,
  urls: PropTypes.shape({
    newProSubscriptionUrl: PropTypes.string.isRequired,
  }).isRequired,
  userTier: PropTypes.oneOf(["free", "intermediate_pro"]).isRequired,
}

export default ProDiyBanner
